<template>
    <div>
        <block-banner class="banner">
            <form @submit.prevent="nextStep">
                <text-headline-primary class="headline">
                    {{ texts.title }}
                </text-headline-primary>

                <div class="row">
                    <div class="field">
                        <field-stop-location-from enable-geo />
                    </div>
                    <div class="field">
                        <field-stop-location-to />
                    </div>
                </div>    

                <div v-if="stopNearAirport" class="row airport-zone-warning">
                    <div>
                        {{ texts.airport_warning }}
                    </div>
                </div>

                <div v-show="fromLocation && toLocation" class="via-and-date-container">
                    <div class="field viaToggleField">
                        <input-checkbox v-model="viaEnabled" white>
                            {{ texts.add_via }}
                        </input-checkbox>
                    </div>

                    <div v-if="viaEnabled" class="row">
                        <div class="field">
                            <field-stop-location-via />
                        </div>
                        <div class="field" />
                    </div>                   

                    <div class="row">
                        <div class="field">
                            <field-date-time floating />
                        </div>
                        <div class="field">
                            <field-passenger floating />
                        </div>
                    </div>

                    <div class="buttonRow">
                        <text-button
                            type="submit"
                            class="nextButton"
                            :disabled="!isStepValid"
                        >
                            {{ texts.next_step_button }}
                        </text-button>
                    </div>
                </div>
            </form>
        </block-banner>

        <block-section>
            <breadcrumb />

            <div class="products">
                <product-card
                    v-for="product in products"
                    :key="product.id"
                    :product="product"
                    class="product"
                />

                <div class="gotoAllProductsContainer">
                    <text-button @click="gotoAllProducts">
                        {{ texts.goto_all_products }}
                    </text-button>
                </div>
            </div>

            <!-- use this when flex tickets should be implemented
            <layout-split>
                <template v-slot:primary>
                    <div class="products">
                        <product-card
                            v-for="product in products"
                            :key="product.id"
                            :product="product"
                            class="product"
                        />

                        <div class="gotoAllProductsContainer">
                            <text-button @click="gotoAllProducts">
                                {{ texts.goto_all_products }}
                            </text-button>
                        </div>
                    </div>
                </template>

                <template v-slot:secondary>
                    <div />
                </template>
            </layout-split>
            -->
        </block-section>
    </div>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import TextButton from "@/components/elements/TextButton";
import InputCheckbox from "@/components/inputs/InputCheckbox";
import FieldStopLocationFrom from "@/components/fields/FieldStopLocationFrom";
import FieldStopLocationTo from "@/components/fields/FieldStopLocationTo";
import FieldStopLocationVia from "@/components/fields/FieldStopLocationVia";
import FieldDateTime from "@/components/fields/FieldDateTime";
import FieldPassenger from "@/components/fields/FieldPassenger";

import ProductCard from "../components/blocks/BlockFixedPriceProductCard";
import BlockBanner from "../components/blocks/BlockBanner";

import paths from "@/router/paths";

export default {
    components: {
        TextButton,
        InputCheckbox,
        BlockBanner,
        FieldStopLocationFrom,
        FieldStopLocationTo,
        FieldStopLocationVia,
        FieldDateTime,
        FieldPassenger,
        ProductCard
    },
    data() {
        return {
            viaEnabledFlag: Boolean(
                this.$store.getters["location/getViaLocation"]
            )
        };
    },
    computed: {
        texts() {
            return this.$t("page_new_zone_ticket");
        },
        viaEnabled: {
            get() {
                return this.viaEnabledFlag;
            },
            set(value) {
                this.viaEnabledFlag = value;
                if (!value) this.$store.commit("location/unsetLocationVia");
            }
        },
        ...mapGetters({
            fromLocation: "location/getFromLocation",
            toLocation: "location/getToLocation",
            isStepValid: "flow/isStepValid",
            stopNearAirport: "location/stopNearAirport"
        }),
        ...mapState({
            products: state =>
                state.products.fixedpriceticket.info.products.slice(0, 6) // use 0, 4 when flex trickets is ready, and using split layout
        })
    },
    created() {
        // support for old time /?dt=xxx paths
        if (this.$route.query.dt) {
            this.$router.replace({
                path: paths.orderConfirmed,
                query: { token: this.$route.query.dt }
            });
        } else if (this.$route.query.id) {
            this.$router.replace({
                path: paths.newFixedPriceTicket,
                query: { productId: this.$route.query.id }
            });
        } else {
            this.$store.dispatch("flow/startZoneTicketFlow");
        }
    },
    methods: {
        gotoAllProducts() {
            this.$router.push(paths.fixedPriceProducts);
        },
        nextStep() {
            return this.$store.dispatch("flow/gotoNextStep");
        }
    }
};
</script>

<style scoped lang="scss">
.headline {
    margin-bottom: 0.5em;
    color: white;
}

.buttonRow {
    text-align: right;
}

.field {
    margin-bottom: 1rem;
}

.viaToggleField {
    font-weight: 600;
    font-size: 0.9rem;
}

.products {
    padding: 1rem 0;
    column-gap: 1rem;
}

.product {
    margin-bottom: 1rem;
    break-inside: avoid;
    display: inline-block;
    width: 100%;
}

/* hide all products except the first two */
.products > .product + .product + .product {
    display: none;
}

.gotoAllProductsContainer {
    text-align: right;
}

.airport-zone-warning {
        border-radius: 25px;
        border: 1px solid white;
        color: white;
        background-color: $color-midttrafik-red;
        padding: 0.6rem;
    }

@media (min-width: $breakpoint-tablet) {
    .field {
        margin-bottom: 1.5rem;
    }

    .row {
        display: flex;
    }

    .row .field {
        flex: 1 1 0px;
    }

    .row .field + .field {
        margin-left: 1.5rem;
    }

    .viaToggleField {
        position: absolute;
        top: 54px;
        right: 24px;
    }

    .products {
        padding: 1.5rem 0;
        column-width: 300px;
        column-gap: 1.5rem;
    }

    .product {
        margin-bottom: 1.5rem;
    }

    /* show all products */
    .products > .product + .product + .product {
        display: inline-block;
    }    

    .airport-zone-warning > div {
        font-weight: 500;
    }

    .via-and-date-container {
        margin-top: 1.5rem;
    }
}
</style>
